import type { ReactNode } from 'react';

interface LinhaConfigProps {
  titulo: ReactNode;
  descricao?: ReactNode;
  /** Controle alinhado à direita (toggle, input, select, botão). */
  children?: ReactNode;
  /** Última linha do painel não leva divisória. */
  ultima?: boolean;
}

/** Linha de configuração Íris: título+descrição à esquerda, controle à direita. */
export default function LinhaConfig({ titulo, descricao, children, ultima = false }: LinhaConfigProps) {
  return (
    <div className={`flex items-center gap-4 py-3.5 ${ultima ? '' : 'border-b border-line'}`}>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-tx">{titulo}</div>
        {descricao && <div className="text-[13px] text-tx-3 mt-0.5">{descricao}</div>}
      </div>
      {children && <div className="shrink-0 flex items-center gap-2">{children}</div>}
    </div>
  );
}
